import { useShop } from "@/context/ShopContext";
import { Reveal } from "@/components/site/Reveal";

const META = {
  shipping: {
    title: "Shipping Policy",
    fallback: "Our shipping policy is being finalized and will be published here shortly. Orders are shipped with standard or express delivery options selected at checkout. If you have questions about a specific order, please contact us with your order number.",
  },
  returns: {
    title: "Returns & Refunds Policy",
    fallback: "Our returns and refunds policy is being finalized and will be published here shortly. If you have an issue with an order, please contact us and we will make it right.",
  },
  privacy: {
    title: "Privacy Policy",
    fallback: "Our privacy policy is being finalized and will be published here shortly. We collect only the information needed to process your order and never sell your personal data. Payments are processed securely by Stripe; we never see or store your card details.",
  },
  terms: {
    title: "Terms & Conditions",
    fallback: "Our terms and conditions are being finalized and will be published here shortly. By using this website you agree to our store policies as published.",
  },
};

export default function Policy({ kind }) {
  const { settings } = useShop();
  const meta = META[kind] || META.shipping;
  const content = settings?.policies?.[kind];

  return (
    <div className="pt-20" data-testid={`policy-${kind}-page`}>
      <div className="bg-[#0A0A0A] gold-hairline-b py-16 sm:py-24 relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 text-center">
          <Reveal>
            <p className="eyebrow mb-4">Kubwalo Fragrances</p>
            <h1 className="font-serif-display text-4xl sm:text-5xl text-white font-light">{meta.title}</h1>
          </Reveal>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-20">
        {content ? (
          <p className="font-sans-body text-base text-[#B8B8B8] font-light leading-relaxed whitespace-pre-wrap" data-testid="policy-content">
            {content}
          </p>
        ) : (
          <>
            <div className="gold-hairline bg-[#0D0D0D] px-5 py-4 mb-8" data-testid="policy-draft-notice">
              <p className="font-sans-body text-xs text-[#C6A15B]">
                Draft policy — pending owner review. This summary will be replaced by the full published policy.
              </p>
            </div>
            <p className="font-sans-body text-base text-[#B8B8B8] font-light leading-relaxed" data-testid="policy-content">
              {meta.fallback}
            </p>
          </>
        )}
        <p className="font-sans-body text-sm text-[#666666] font-light mt-12">
          Questions about this policy? <a href="/contact" className="text-[#D4AF37] underline underline-offset-4">Contact us</a>.
        </p>
      </div>
    </div>
  );
}
